exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".max-email-height {\n  max-height: 500px;\n  overflow: auto;\n}\n.sequence-background {\n  background: #fffd78;\n}\n.cke_editable .projectDataHidden {\n  display: none;\n}\n.bv-no-focus-ring .input-group #subject {\n  border: 1px solid #a7acb6;\n  padding: unset;\n}\n#wsc_img_banner {\n  display: none !important;\n}\n", ""]);

// exports
